'use client';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CharacterPricingPanel } from "@/components/translate/character-pricing-panel";
import { useTranslations } from "next-intl";

interface CharacterPricingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CharacterPricingDialog({ open, onOpenChange }: CharacterPricingDialogProps) {
  const t = useTranslations('usage');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[520px] max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="text-start">{t('pricingDialogTitle')}</DialogTitle>
          <DialogDescription className="text-start">
            {t('pricingDialogDescription')}
          </DialogDescription>
        </DialogHeader>

        <div className="overflow-y-auto">
          <CharacterPricingPanel onTermsClick={() => onOpenChange(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
}